(function () {
  const STORAGE_KEY = 'granvia-scroll-position';
  const RESTORE_DELAY = 100;

  // Permitimos que nuestro script controle la restauración.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function saveScrollPosition() {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        url: window.location.href,
        scrollY: window.scrollY
      })
    );
  }

  function restoreScrollPosition() {
    const saved = sessionStorage.getItem(STORAGE_KEY);

    if (!saved) return;

    try {
      const data = JSON.parse(saved);

      if (data.url !== window.location.href) return;

      sessionStorage.removeItem(STORAGE_KEY);

      setTimeout(function () {
        window.scrollTo({
          top: data.scrollY,
          behavior: 'instant'
        });
      }, RESTORE_DELAY);

    } catch (error) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }

  // Guardamos la posición cuando el usuario abandona la página.
  window.addEventListener('pagehide', saveScrollPosition);

  // Restauramos cuando vuelve mediante Atrás/Adelante.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      restoreScrollPosition();
    }
  });

  // También intentamos restaurar cuando el documento vuelve a estar visible.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScrollPosition);
  } else {
    restoreScrollPosition();
  }
})();